import createIcon from '../../createIcon';

/**
 * @component @name Face4
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgM0MxMi4wNCAzIDExLjEyIDMuMTQgMTAuMjUgMy4zOUM5LjM3IDEuOTYgNy44IDEgNiAxQzMuMjQgMSAxIDMuMjQgMSA2QzEgNy44IDEuOTYgOS4zNyAzLjM5IDEwLjI1QzMuMTQgMTEuMTIgMyAxMi4wNCAzIDEzQzMgMTguNTIgNy40OCAyMyAxMyAyM0MxOC41MiAyMyAyMyAxOC41MiAyMyAxM0MyMyA3LjQ4IDE4LjUyIDMgMTMgM1pNMTMgMjFDOC41OSAyMSA1IDE3LjQxIDUgMTNDNSAxMi45NSA1LjAxIDEyLjkgNS4wMSAxMi44NUM3LjYxIDExLjg3IDkuNjkgOS44NiAxMC43NSA3LjNDMTIuNTggOS41NiAxNS4zNyAxMSAxOC41IDExQzE5LjI1IDExIDE5Ljk3IDEwLjkxIDIwLjY3IDEwLjc2QzIwLjg4IDExLjQ3IDIxIDEyLjIyIDIxIDEzQzIxIDE3LjQxIDE3LjQxIDIxIDEzIDIxWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEwIDE1LjI1QzEwLjY5MDQgMTUuMjUgMTEuMjUgMTQuNjkwNCAxMS4yNSAxNEMxMS4yNSAxMy4zMDk2IDEwLjY5MDQgMTIuNzUgMTAgMTIuNzVDOS4zMDk2NCAxMi43NSA4Ljc1IDEzLjMwOTYgOC43NSAxNEM4Ljc1IDE0LjY5MDQgOS4zMDk2NCAxNS4yNSAxMCAxNS4yNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNiAxNS4yNUMxNi42OTA0IDE1LjI1IDE3LjI1IDE0LjY5MDQgMTcuMjUgMTRDMTcuMjUgMTMuMzA5NiAxNi42OTA0IDEyLjc1IDE2IDEyLjc1QzE1LjMwOTYgMTIuNzUgMTQuNzUgMTMuMzA5NiAxNC43NSAxNEMxNC43NSAxNC42OTA0IDE1LjMwOTYgMTUuMjUgMTYgMTUuMjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Face4 = createIcon('Face4', [
  [
    'path',
    {
      d: 'M13 3C12.04 3 11.12 3.14 10.25 3.39C9.37 1.96 7.8 1 6 1C3.24 1 1 3.24 1 6C1 7.8 1.96 9.37 3.39 10.25C3.14 11.12 3 12.04 3 13C3 18.52 7.48 23 13 23C18.52 23 23 18.52 23 13C23 7.48 18.52 3 13 3ZM13 21C8.59 21 5 17.41 5 13C5 12.95 5.01 12.9 5.01 12.85C7.61 11.87 9.69 9.86 10.75 7.3C12.58 9.56 15.37 11 18.5 11C19.25 11 19.97 10.91 20.67 10.76C20.88 11.47 21 12.22 21 13C21 17.41 17.41 21 13 21Z',
      key: '141xnf',
    },
  ],
  [
    'path',
    {
      d: 'M10 15.25C10.6904 15.25 11.25 14.6904 11.25 14C11.25 13.3096 10.6904 12.75 10 12.75C9.30964 12.75 8.75 13.3096 8.75 14C8.75 14.6904 9.30964 15.25 10 15.25Z',
      key: '1tull9',
    },
  ],
  [
    'path',
    {
      d: 'M16 15.25C16.6904 15.25 17.25 14.6904 17.25 14C17.25 13.3096 16.6904 12.75 16 12.75C15.3096 12.75 14.75 13.3096 14.75 14C14.75 14.6904 15.3096 15.25 16 15.25Z',
      key: '1ot4w3',
    },
  ],
]);

export default Face4;
